import React, { useCallback } from 'react'; // eslint-disable-line
import PropTypes from 'prop-types';
import * as utils from '../../shared/utils';

const BreadcrumbsItem = ({ _id, title, onClick }) => {
  const handleClick = useCallback(() => {
    onClick(_id);
  }, [_id, onClick]);

  return (
    <li className={_id ? null : 'disabled'}>
      <span
        onClick={handleClick}
        role="button"
        onKeyDown={handleClick}
        tabIndex={0}
      >
        {utils.decodeSlash(title)}
      </span>
    </li>
  );
};

BreadcrumbsItem.propTypes = {
  _id: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]).isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default BreadcrumbsItem;
